import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const HospitalRoute = () => {
    const navigate = useNavigate();

    React.useEffect(() => {
        const hospitalTime = sessionStorage.getItem('hospitalTime');
        const currentTime = Date.now();

        if (!hospitalTime) {
            navigate('/', { replace: true });
            return;
        }

        if (currentTime >= Number.parseInt(hospitalTime, 10)) {
            sessionStorage.clear();
            navigate('/', { replace: true });
        }
    }, [navigate]);

    return <Outlet />;
};

export default HospitalRoute;
